import { render, staticRenderFns } from "./DescriptionWithLinks.vue?vue&type=template&id=0f5dc4ec&scoped=true&"
import script from "./DescriptionWithLinks.vue?vue&type=script&lang=js&"
export * from "./DescriptionWithLinks.vue?vue&type=script&lang=js&"
import style0 from "./DescriptionWithLinks.vue?vue&type=style&index=0&id=0f5dc4ec&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f5dc4ec",
  null
  
)

export default component.exports